export class IframeEvents {
    static _registeredListeners = [];
    /**
     * Initializes the message event listener for an iframe
     * Listens for both resize and redirect events from the specified iframe
     * Registers the listener only once per allowed origin and iframe ID combination
     * @param allowedOrigin - The allowed origin for security validation
     * @param iframeId - The ID of the iframe to listen to
     */
    static initMessageListener(allowedOrigin, iframeId) {
        const listenerKey = `${allowedOrigin}:${iframeId}`;
        if (this._registeredListeners.indexOf(listenerKey) > -1) {
            return;
        }
        this._registeredListeners.push(listenerKey);
        window.addEventListener('message', (event) => {
            this._resizeHandler(allowedOrigin, iframeId, event);
            this._redirectHandler(allowedOrigin, iframeId, event);
        });
    }
    /**
     * Handles resize messages from iframes
     * Updates the iframe height based on message data
     * @param allowedOrigin - The allowed origin for security validation
     * @param iframeId - The ID of the iframe to resize
     * @param event - The message event from the iframe
     */
    static _resizeHandler(allowedOrigin, iframeId, event) {
        if (event.origin === allowedOrigin && event.data.type === 'resize') {
            const iFrame = document.getElementById(iframeId);
            if (!iFrame) {
                this._logError(`Iframe with ID '${iframeId}' not found. Cannot handle resize.`);
                return;
            }
            iFrame.style.height = `${event.data.height}px`;
        }
    }
    /**
     * Handles redirect messages from iframes
     * Redirects the window to the specified URL
     * @param allowedOrigin - The allowed origin for security validation
     * @param iframeId - The ID of the iframe sending the redirect
     * @param event - The message event from the iframe
     */
    static _redirectHandler(allowedOrigin, iframeId, event) {
        if (event.origin === allowedOrigin && event.data.type === 'redirect') {
            const iFrame = document.getElementById(iframeId);
            if (!iFrame) {
                this._logError(`Iframe with ID '${iframeId}' not found. Cannot handle redirect.`);
                return;
            }
            window.location.href = event.data.url;
        }
    }
    static _logError(message) {
        console.error(`IframeEvents: ${message}`);
    }
}
